import { render, staticRenderFns } from "./SubColecoes.vue?vue&type=template&id=7883d956&scoped=true"
import script from "./SubColecoes.vue?vue&type=script&lang=js"
export * from "./SubColecoes.vue?vue&type=script&lang=js"
import style0 from "./SubColecoes.vue?vue&type=style&index=0&id=7883d956&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7883d956",
  null
  
)

export default component.exports